import { Input, Select } from 'antd';
import { MoreVerticalIcon } from '../../../utils/icons';

export const columns = [
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    width: '250px',
    render: (data: any) => {
      return <Input defaultValue={data} />;
    },
  },
  {
    title: 'Cost Per',
    dataIndex: 'costPer',
    key: 'costPer',
    render: (data: any) => {
      return <Input style={{ width: 120 }} defaultValue={data} />;
    },
  },
  {
    title: 'Action',
    key: 'action',

    width: '80px',
    render: (data: any) => {
      return <MoreVerticalIcon />;
    },
  },
];
